/* eslint-disable max-len */
import { post } from './common';
const merchantCodeApiPrefix = '/Services/MerchantCodeService.asmx';
export const getMerchantCodes = async (payload) => {
    const result = (await (await post(`${merchantCodeApiPrefix}/GetMerchantCodes`, {
        Payload: payload
    })).json()).d;
    if (result.Status !== 'success') {
        throw new Error(result.Message);
    }
    return JSON.parse(result.Data);
};
export const saveMerchantCodesByCategory = async (payload) => {
    const result = (await (await post(`${merchantCodeApiPrefix}/SaveMerchantCodesByCategory`, {
        Payload: payload
    })).json()).d;
    if (result.Status !== 'success') {
        throw new Error(result.Message);
    }
};
export const saveMerchantCodeBatchByCategory = async (payload) => {
    const result = (await (await post(`${merchantCodeApiPrefix}/SaveMerchantCodeBatchByCategory`, {
        Payload: payload
    })).json()).d;
    if (result.Status !== 'success') {
        throw new Error(result.Message);
    }
};
export const getMerchantCodesPageload = async (encryptedExpCatId) => {
    const result = (await (await post(`${merchantCodeApiPrefix}/GetMerchantCodesPageloadObject`, {
        encryptedExpCatId
    })).json()).d;
    if (result.Status !== 'success') {
        throw new Error(result.Message);
    }
    return JSON.parse(result.Data);
};
